import React, {FC} from 'react';
import claimedCoinsExplosion from '../../../assets/mweb-coins-explosion.riv';
import {CoinsExplosionAnimation} from './CoinsExplosionAnimation';

export const CoinsExplosionAnimationSquare: FC<{showBodyContent: boolean}> = ({
  showBodyContent,
}) => (
  <CoinsExplosionAnimation
    showBodyContent={showBodyContent}
    riveSrc={claimedCoinsExplosion}
  />
);
